module.exports = __webpack_public_path__ + "public/img/new_certificate_front.bf1236ef.png";